export default __webpack_public_path__ + "static/media/gwn33.e345fb93.webp";